import cn from 'classnames';
import CountUp from 'react-countup';
import { ReactComponent as DotIcon } from '@assets/svg/dot.svg';
import styles from './active-players.module.scss';

interface IProps {
  activePlayers: number;
  className?: string;
}

/** Expressed in Seconds */
const COUNT_UP_DURATION = 1;

const ActivePlayersCount = ({
  activePlayers,
  className = '',
}: IProps): JSX.Element => (
  <div className={cn(styles['active-players'], className)}>
    <DotIcon />
    <span>
      <CountUp end={activePlayers} duration={COUNT_UP_DURATION} />
    </span>
  </div>
);

export default ActivePlayersCount;
